export const BREAKPOINTS = {
  mobile: 768,
  desktop: 769,
  narrow: 1024,
  wide: 1025,
};

export const isMobileView = () =>
  window.matchMedia(`(max-width: ${BREAKPOINTS.mobile}px)`).matches;

export const isNarrowView = () =>
  window.matchMedia(`(max-width: ${BREAKPOINTS.narrow}px)`).matches;